@use '../shared-styles' as *;
@use '../../design-tokens/typography/typography' as *;

@layer design-system {
  .chartSvg {
    @include root-svg;
  }

  .timeSeriesLine {
    fill: none;
    stroke: var(--viz-bearish);
    stroke-width: 1px;
  }

  .timeSeriesLineBullish {
    stroke: var(--viz-bullish);
  }

  .targetLine {
    fill: none;
    stroke: var(--viz-bullish);
    stroke-width: 1px;
    stroke-dasharray: none;
  }

  .targetLineBearish {
    stroke: var(--viz-bearish);
  }

  .targetLineAverage {
    stroke-dasharray: 4 4;
  }

  .dividerLine {
    stroke: var(--border-soft);
    stroke-dasharray: 2 2;
    stroke-width: 1px;
  }

  .axisLine {
    @include axis-line;
    stroke-width: 0.5px;
  }

  .xAxisLine {
    @include axis-line;
    stroke-width: 1px;
  }

  .axisText {
    @include axis-text;
    font-size: 14px;
  }

  .xAxisText {
    @include axis-text;
    font-size: 14px;
  }
}
